import { Suspense } from 'react'
import { WebhookSwitcherFallback } from '@/components/layout/breadcrumbs/webhook/webhook-switcher/fallback'
import { WebhookSwitcherData } from '@/components/layout/breadcrumbs/webhook/webhook-switcher/switcher'

export const WebhookSwitcher = () => (
  <Suspense fallback={<WebhookSwitcherFallback />}>
    <WebhookSwitcherData />
  </Suspense>
)
